const { format } = require("date-fns");

require("./clock");
require("./slider");
require("./time");

function handleAlertClose(event) {
  let target = event.target;
  let found = false;
  while (target != null) {
    if (target.getAttribute("data-component") &&
      target.getAttribute("data-component") === "enj-alert") {
      found = true;
      break;
    }
    target = target.parentNode;
  }
  if (found) {
    target.style.display = "none";
  }
}
  
window.addEventListener("turbo:load", () => {
  const alertCloseButtons = document.querySelectorAll(".notification-item");
  const memoryGameInputField = document.getElementById("uploaded_images");
  const memoryImagesContainer = document.querySelector(".upload-images")
  const imagesContainer = document.querySelector(".images-container");
  alertCloseButtons.forEach((element) => {
    element.addEventListener("click", handleAlertClose);
  });



  // Custom input file
  const customInputs = document.querySelectorAll(".custom-input-label");
  customInputs.forEach((el) => {
    el.addEventListener("drop", dropFile, false);
    el.addEventListener("dragover", dragOver, false);
    el.addEventListener("change", changeFile, false);
  });



  const dt = new DataTransfer();


  function changeFile(event) {
    event.preventDefault();
    const date = new Date();
    var fullPath = event.target.value;
    
    if (event.target.multiple && imagesContainer) {
      showImages(event.target);
      var files = event.target.files;
      for (var i = 0; i < files.length; i++) {
        dt.items.add(files[i]);   
      }
      event.target.files = dt.files;
      return;
    }

    if (fullPath) {
      var startIndex =
        fullPath.indexOf("\\") >= 0
          ? fullPath.lastIndexOf("\\")
          : fullPath.lastIndexOf("/");
      var filename = fullPath.substring(startIndex);
      if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
        filename = filename.substring(1);
        event.target.parentNode.classList.add("dropped");
        event.target.parentNode.querySelector(
          ".custom-input-label_text"
        ).textContent = filename;
      // if(event.target.files.length) {
      //   console.log(5);
      //   event.target.forEach(file => readImage(file, ev.target))
      // }
    }
    }
  }

  function readImage (file, element) {
    console.log(6);
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      element.parentNode.parentNode.querySelector(".custom-input-label_logo").src = event.target.result;
    });
    reader.readAsDataURL(file);
 }

  function dropFile(ev) {
    ev.preventDefault();

    const date = new Date();
    let dt = ev.dataTransfer;
    let files = dt.files;

    if (imagesContainer) {
      showImages(ev.target.querySelector(".custom-input-file"));
      ev.target.querySelector(".custom-input-file").files = files;
      return;
    }

    ev.target.classList.add("dropped");
    ev.target.querySelector(".custom-input-file").files = files;
  }

  function dragOver(ev) {
    ev.preventDefault();
  }

  function showImages(input) {
    
    const files = input.files;
    Object.entries(files).forEach(async ([key, val]) => {
      const img = document.createElement("img");
      const div = document.createElement("div");
      const url = URL.createObjectURL(val);
      const removeButton = document.createElement("a");

      div.classList.add("image");
      img.classList.add('image-preview')
      div.setAttribute("style", "width: 76px; height: 60px");
      img.src = url;
      div.appendChild(img);
      div.appendChild(removeButton);
      if(memoryImagesContainer){
        removeButton.classList = "remove-icon";
        imagesContainer.style.gap = "3rem";
        removeButton.innerHTML = `<span style='color: red' class="material-icons">
        highlight_off
        </span>`;
        img.setAttribute("data-action", "click->game-campaign#select_multiple");
        img.setAttribute("data-status", "uploaded");

// request will be send from these line
        var id = await upload_file(files[key]);
        removeButton.setAttribute("href", `/company/uploads/remove?image_id=${id}`)
        removeButton.setAttribute("data-turbo-method", "post")
        removeButton.setAttribute("data-action", "click->game-campaign#remove_button")
        img.setAttribute("data-id", id)
      } else {
        removeButton.innerHTML = `<img src="/assets/trash.svg" />`;
      }

      imagesContainer.appendChild(div);

      removeButton.addEventListener('click', (e) => {
        e.preventDefault();

        const files = Array.from(input.files).filter((file) => file != val);
        const dt = new DataTransfer();
        for (var file of files) {
          dt.items.add(file);
        }

        input.files = dt.files;
        imagesContainer.removeChild(div);
        let imagesCount = document.getElementById("images-count");
        imagesCount.innerHTML = parseInt(imagesCount.innerHTML) - 1;
      });
    });
  }

  async function upload_file(file){
    var id = document.getElementById("game_campaign_id").value;
    var data = new FormData()
    var isSlot = document.getElementById("game_type").value;
    if(isSlot !== null && isSlot === "slot"){
      data.append("type", "slot")
    }
    else{
      data.append("type", "memory")
    }
    data.append("uploaded_image", file)
    const response = await fetch(`/company/game_campaigns/${id}/upload_images`, {
      method: "POST",
      body: data,
    });
    const responseData = await response.json();
    return responseData.attachment_id;
  }

  // Accordion
  const acc = document.querySelectorAll(".accordion");

  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      const panel = this.previousElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }

  const btnCategories = document.getElementById("categories_all");
  const hiddenCategories = document.querySelectorAll("#hidden_category")
  if(btnCategories){
    var translations = {
      see_all: current_locale === "en" ? "Show all" : "Alle anzeigen",
      hide: current_locale === "en" ? "Hide" : "Ausblenden"
    }
    btnCategories.addEventListener("click", function(){
      hiddenCategories.forEach(element => {
        if (element.classList.contains('hidden')) {
          element.classList.remove('hidden');
          setTimeout(function () {
            element.classList.remove('visuallyhidden');
          }, 20);
          btnCategories.innerText = translations.hide;
        } else {
          element.classList.add('visuallyhidden');    
          element.addEventListener('transitionend', function(e) {
            element.classList.add('hidden');
          }, {
            capture: false,
            once: true,
            passive: false
          });
          btnCategories.innerText = translations.see_all;
        } 
      }, false);
    });
  }

  
  const inputContainer = document.querySelector('.fixed-input-container');
  const inputElement = document.getElementById('promocode');
  
  if(inputElement && inputContainer){
    const keyboardHeight = window.innerHeight * 0.1; // Adjust the height as needed
    const deviceType = inputContainer.getAttribute("device-type");
    if(deviceType === "android"){
      inputElement.addEventListener('focusin', () => {      
        inputContainer.style = `margin-top: -${keyboardHeight}px`;
      });
  
      inputElement.addEventListener('focusout', () => {   
        inputContainer.style = 'margin-top: 30px';
      });
  
      inputElement.addEventListener('blur', () => {
        inputContainer.style = 'margin-top: 30px';
      });
      let windowHeight = window.innerHeight;
      visualViewport.addEventListener('resize', (event) => {
        const resizedHeight = event.target.height;
        if(resizedHeight === windowHeight){
          inputContainer.style = 'margin-top: 30px';
        } else {
          inputContainer.style = `margin-top: -${keyboardHeight}px`;
        }
        // inputElement.setAttribute('value', `${h} : ${windowHeight}`)
      });
    }
  }

});